import React from 'react'
import PropTypes from 'prop-types'

import Card from '@material-ui/core/Card'
import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import CardContent from '@material-ui/core/CardContent'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
  main: {
    display: 'flex',
    position: 'relative',
    [theme.breakpoints.down('xl')]: {
      paddingLeft: theme.spacing(8),
    },
    [theme.breakpoints.up('xl')]: {
      paddingLeft: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1),
    },
  },
  container: {
    width: '100%',
    height: '100%',
    flex: '1 1 100%',
  },
  card: {
    minHeight: '100%',
    display: 'flex',
    width: '100%',
    height: '100%',
    borderRadius: 0,
    boxShadow: 'none',
    background: 'transparent',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2, 3),
      paddingRight: 0,
    },
  },
  cardBody: {
    minHeight: '100%',
    width: '100%',
    zIndex: 'auto',
    position: 'relative',
  },
  btn: {
    width: '100%',
  },
}))

const Main = ({ children }) => {
  const classes = useStyles()

  return (
    <Container maxWidth="xl" className={classes.main}>
      <Grid container className={classes.container}>
        <Card className={classes.card}>
          <CardContent className={classes.cardBody}>
            {children}
          </CardContent>
        </Card>
      </Grid>
    </Container>
  )
}

Main.propTypes = {
  children: PropTypes.element.isRequired,
}

export default Main
